// custom typefaces
import "@fontsource/montserrat/variable.css"
import "@fontsource/merriweather"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
// https://github.com/PrismJS/prism/tree/master/themes
// require("prismjs/themes/prism.css")
require("prismjs/themes/prism-twilight.css")
require("prismjs/plugins/line-numbers/prism-line-numbers.css")
require("prismjs/plugins/command-line/prism-command-line.css")

require("katex/dist/katex.min.css")